<template>
  <div
    v-if="alwaysShow || itemsCount > minItems"
    class="swiper-image__controls"
    :class="{
      '-larger': larger,
      '-voyage': voyage,
    }"
  >
    <template v-if="voyage">
      <button
        type="button"
        class="swiper-image__control-button -left"
        aria-label="Précédent"
        @click.stop="swiper.slidePrev()"
      >
        <Icon id="arrow" />
      </button>

      <button
        type="button"
        class="swiper-image__control-button"
        aria-label="Suivant"
        @click.stop="swiper.slideNext()"
      >
        <Icon id="arrow" />
      </button>
    </template>

    <template v-else>
      <div class="swiper-image__control" @click.stop="swiper.slidePrev()">
        <button type="button" class="swiper-image__control-button -left" aria-label="Précédent">
          <Icon id="arrow" />
        </button>
      </div>

      <div class="swiper-image__control" @click.stop="swiper.slideNext()">
        <button type="button" class="swiper-image__control-button" aria-label="Suivant">
          <Icon id="arrow" />
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { useSwiper } from 'swiper/vue'

import Icon from '@/components/global/Icon.vue'

export default {
  name: 'SectionSwiperControls',

  components: {
    Icon,
  },

  props: {
    itemsCount: {
      type: Number,
      required: true,
    },

    minItems: {
      type: Number,
      default: 3,
    },

    alwaysShow: {
      type: Boolean,
      default: false,
    },

    larger: {
      type: Boolean,
      default: false,
    },

    voyage: {
      type: Boolean,
      default: false,
    },
  },

  setup: () => ({
    swiper: useSwiper(),
  }),
}
</script>
